import { render, staticRenderFns } from "./back-stock-batch-pack.vue?vue&type=template&id=5c22ac15&scoped=true"
import script from "./back-stock-batch-pack.vue?vue&type=script&lang=ts"
export * from "./back-stock-batch-pack.vue?vue&type=script&lang=ts"
import style0 from "./back-stock-batch-pack.vue?vue&type=style&index=0&id=5c22ac15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c22ac15",
  null
  
)

export default component.exports